import { defineMessages } from 'react-intl';

export default defineMessages({
    welcome: {
        id: 'header.text.Welcome',
        defaultMessage: 'Welcome'
    }
});
